<script>
export default {
  computed: {
    storyId () {
      return this.$route.params.storyId
    },
    storyList () {
      let docs

      if (this.$route.meta.version === 'raz') {
        docs = this.docs.razstory
      } else {
        docs = this.docs.story
      }

      const keys = Object.keys(docs)
        .sort((a, b) => (a - 0) > (b - 0) ? 1 : -1)
      const list = []
      keys.forEach(key => {
        if (key !== 'introduction') {
          list.push({
            ...docs[key],
            id: key
          })
        }
      })
      return list
    }
  }
}
</script>

<template>
  <div class="gp-story">
    <div class="page-background"></div>

    <header>
      <h1 class="page-title">STORY</h1>

      <div class="tab level-center is-mobile">
        <router-link :to="{ name: 'story-article', params: {storyId: '1'} }">
          <h2
            class="gp level-center is-mobile"
            :class="{ current: !$route.meta.version }"
          >
            <img src="/assets/images/logo-gp-kana.svg" />
          </h2>
        </router-link>

        <router-link :to="{ name: 'raz-story-article', params: {storyId: '1'} }">
          <h2
            class="raz level-center is-mobile"
            :class="{ current: $route.meta.version === 'raz' }"
          >
            <img src="/assets/images/logo-gp-kana-raz.svg" />
          </h2>
        </router-link>
      </div>

      <nav class="is-family-oswald has-text-weight-bold has-text-align-center">
        <div
          v-if="$route.meta.version !== 'raz'"
          class="is-size-3 is-size-4-mobile"
          :class="{current: $route.name === 'story-introduction'}"
        >
          <router-link :to="{name: 'story-introduction'}">
            <span>INTRODUCTION</span>
          </router-link>
        </div>

        <ul class="level is-mobile is-size-3 is-size-5-mobile">
          <li
            v-for="story in storyList"
            :key="story.id"
            :class="{current: storyId === story.id}"
          >
            <router-link
              v-if="$route.meta.version === 'raz'"
              :to="{ name: 'raz-story-article', params: { storyId: story.id } }"
            >
              <span>{{ story.no }}</span>
            </router-link>

            <router-link
              v-else
              :to="{ name: 'story-article', params: { storyId: story.id } }"
            >
              <span>{{ story.no }}</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </header>

    <div class="transition-container">
      <transition name="slide-in">
        <router-view :key="$route.path"></router-view>
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gp-story {
  nav {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: .5rem;
    min-height: 4.75rem;

    @include is-mobile {
      width: 100%;
    }
    @include is-not-mobile {
      max-width: 60rem;
      width: calc(100% - 6rem);
      margin: auto;
    }
    color: $white;
    background-color: $black;
    padding: .75rem 1.5rem .75rem;
    ul {
      justify-content: center;
      flex-wrap: wrap;
      li {
        padding: 0 .5rem;
        padding-bottom: 0;
      }
    }
    .current span,
    span:hover {
      color: $yellow;
    }
  }
}

.tab {
  align-items: flex-start !important;

  @include is-mobile {
    height: 3rem;
    gap: .75rem;
  }

  @include is-not-mobile {
    height: 4.5rem;
    gap: 2.5rem;
  }

  h2 {
    padding-bottom: 0;
    transition: padding-bottom .06s ease, opacity .06s linear;
    opacity: .7;

    @include is-mobile {
      height: 2rem;
      width: 10.25rem;
    }

    @include is-not-mobile {
      height: 3rem;
      width: 17rem;
    }

    &.current {
      opacity: 1;
      @include is-mobile {
        padding-bottom: 1rem;
      }

      @include is-not-mobile {
        padding-bottom: 1.5rem;
      }
    }
  }

  h2.gp {
    background-color: #B20C1A;

    img {
      @include is-mobile {
        width: 8rem;
      }
    }
  }

  h2.raz {
    background-color: #FFF;

    img {
      @include is-mobile {
        width: 9.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/story/story.vue